// components/URLListener.tsx
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { addUrl } from '../../store/slices/PersistInstanceSlice';

const URLListener = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Simulate WebSocket behavior
    const simulatedMessages = [
      { url: 'https://env-69f4f5a0.machinehack-new.clients.kloudlite.io', name: 'n8n', envId: 'env-69f4f5a0' },
      { url: 'https://env-012fad24.machinehack-new.clients.kloudlite.io', name: 'VS Code', envId: 'env-012fad24' },
      { url: 'https://env-bcc8e1a3.machinehack-new.clients.kloudlite.io', name: 'Autogen Studio', envId: 'env-bcc8e1a3' },
    ];

    simulatedMessages.forEach((msg, index) => {
      setTimeout(() => {
        dispatch(addUrl({ url: msg.url, name: msg.name, envId: msg.envId }));
        console.log('Simulated URL added:', { url: msg.url, name: msg.name, envId: msg.envId });
      }, 1000 * (index + 1)); // 1s, 2s, 3s, etc.
    });

    // Cleanup (if needed later for real WebSocket)
    return () => { };
  }, [dispatch]);

  return null;
};

export default URLListener;
